import { Farm } from './farm';

export class FarmCadastralSheet {
  id: number;
  status: string;
  city: string;
  sheet: string;
  fileUrl: string;
  farm: Farm;
  constructor() {
    this.id = null;
    this.status = 'waiting';
    this.city = null;
    this.sheet = null;
    this.farm = null;
  }
}
/*
*********** MODELLO DI BACKEND **********************
package com.xfarm.api.v1.map

import com.xfarm.api.v1.core.Farm

class FarmCadastralSheet {
    string status = 'waiting'
    string  city
    string  sheet
    string  fileUrl

    static constraints = {
        status      blank:false, nullable:false, inList: ['waiting', 'rejected', 'done']
        city        blank: false, nullable: false
        sheet       blank: false, nullable: false
        fileUrl     blank: false, nullable: true, url: true
    }
    static belongsTo      = [farm: Farm]
}


*/
